
    <div>
        <div class="vr js-element--viewFilesList">
            <div class="isDelayed isDelayed_med"></div>
        </div>
    </div>
    <div class="globalDialog-ft globalDialog-ft_alignRight">
        <div class="hList hList_spread js-actionsContainer">
            <div><a href="" class="link js-action--cancel">cancel</a></div>
            <div><a href="{{personalizeUrl}}" class="btn">Edit</a></div>
        </div>
    </div>
